import React from "react";
import { Accordion } from "react-bootstrap";
import "./Homefaq.css";

const Homefaq = ({ faq = [] }) => (
  <section id="about-2" className="home-faq" aria-labelledby="home-faq-title">
    <div className="container">
      <div className="home-faq__layout">
        <div className="home-faq__intro">
          <span className="home-faq__eyebrow">A LITTLE CLARITY</span>
          <h2 id="home-faq-title">Big plans.<br />Simple <span>answers.</span></h2>
          <p>Everything you need to know to take the next step in your UAE business journey.</p>
          <div className="home-faq__note">
            <span className="home-faq__note-icon" aria-hidden="true">?</span>
            <div><strong>Good questions. Clear answers.</strong><span>Let’s make getting started a little easier.</span></div>
          </div>
        </div>
        <div className="home-faq__questions">
          <div className="home-faq__list-heading">Frequently asked questions</div>
          <Accordion defaultActiveKey="0">
            {faq.map((f, i) => (
              <Accordion.Item key={i} eventKey={i}>
                <Accordion.Header>
                  <span className="home-faq__number" aria-hidden="true">{String(i + 1).padStart(2, "0")}</span>
                  <span className="home-faq__question">{f.qus}</span>
                  <span className="home-faq__toggle" aria-hidden="true" />
                </Accordion.Header>
                <Accordion.Body>{f.ans}</Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
      </div>
    </div>
  </section>
);

export default Homefaq;
